<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Selección de Elementos del Documento</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="form-group col-6" id="tipoDocumento_div">
                    <label>Tipo : {{DocumentoPadre.TipoDocumento.Nombre}}</label>
                </div>
                <div class="form-group col-6" id="consecutivo_div">
                    <label>{{DocumentoPadre.Consecutivo}}/{{DocumentoPadre.Anio}}</label>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12" id="tabla">
                    <div id="TablaElementos">
                        <table class="table table-striped table-light table-hover table-sm table-bordered" v-if="Volumenes.length>0" >
                            <thead class="thead-dark">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Numero</th>
                                        <th></th>
                                    </tr>
                            </thead>
                            <tbody class="text-dark">
                                <tr v-for="Lista in Volumenes" :key= Lista.VolumenId>
                                    <td>Volumen</td>
                                    <td>{{Lista.NumVolumen}}</td>
                                    <td witdh ="30">
                                            <input type="checkbox" v-model="ListaVolumenes" v-bind:value="Lista.VolumenId"/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-striped table-light table-hover table-sm table-bordered" v-if="Incidentes.length>0">
                            <thead class="thead-dark">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Numero</th>
                                        <th></th>
                                    </tr>
                            </thead>
                            <tbody class="text-dark">
                                <tr v-for="Lista in Incidentes" :key= Lista.IncidenteId>
                                    <td>Incidente</td>
                                    <td>{{Lista.NumeroIncidente}}</td>
                                    <td witdh ="30">
                                            <input type="checkbox" v-model="ListaIncidentes" v-bind:value="Lista.IncidenteId"/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-striped table-light table-hover table-sm table-bordered" v-if="Tercerias.length>0">
                            <thead class="thead-dark">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Numero</th>
                                        <th></th>
                                    </tr>
                            </thead>
                            <tbody class="text-dark">
                                <tr v-for="Lista in Tercerias" :key= Lista.TerceriaId>
                                    <td>Tercería</td>
                                    <td>{{Lista.NumeroTerceria}}</td>
                                    <td witdh ="30">
                                            <input type="checkbox" v-model="ListaTercerias" v-bind:value="Lista.TerceriaId"/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button>
          <button type="button" class="btn btn-dark" id="botonAceptar" >Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {
    props: {
        DocumentoPadre: {}
    },
    data(){
        return{
            DocumentoParaLista: {},
            Volumenes:[],
            Incidentes: [],
            Tercerias:[],
            ListaElementos:[],
            ListaVolumenes: [],
            ListaIncidentes: [],
            ListaTercerias: []
        }
    },
    methods: {
        Mostrar: function () {
            $('#modalEnvio').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonAceptar').unbind('click').click(this.ModificarDocumento);
            },
        ModalClose: function(Objeto, vols, incs, ters){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {"InventarioDocumentoId": Objeto, "Volumenes": vols, "Incidentes": incs, "Tercerias":ters});
        },
        ModificarDocumento(){
            //var vols = this.GeneramosVolumen();
            var InventarioDocumentoId= this.DocumentoParaLista.InventarioDocumentoId;
            var Volumenes = this.GeneramosVolumen();
            var Incidentes = this.GeneramosIncidente();
            var Tercerias = this.GeneramosTerceria();
    
            if(Volumenes.length>0 ||Incidentes.length>0 || Tercerias.length>0)            
            {
                this.ModalClose(InventarioDocumentoId, Volumenes, Incidentes, Tercerias);
            }
            else
            {
                comun.mensajeDeAlerta("Seleccione los elementos que formaran parte del envío", null, null);
            }
            
        },
        GeneramosVolumen(){
            let VolumenesEnLista = [];

                    this.ListaVolumenes.forEach((element) =>{
                    let AgregaVol = this.Volumenes.find(vol =>vol.VolumenId == element);
                            VolumenesEnLista.push(
                            AgregaVol)
                    })
                
            return VolumenesEnLista;
        },
        GeneramosIncidente(){
            let IncidentesEnLista = [];
            
                    this.ListaIncidentes.forEach((element) =>{
                    let AgregaInc = this.Tercerias.find(vol =>vol.IncidenteId == element);
                   
                            IncidentesEnLista.push(
                            AgregaInc)
                    })
            return IncidentesEnLista;
        },
        GeneramosTerceria(){
            let TerceriasEnLista = [];
            
                    this.ListaTercerias.forEach((element) =>{
                    let AgregaTer = this.Tercerias.find(vol =>vol.TerceriaId == element);
                    
                            TerceriasEnLista.push(
                            AgregaTer)
                    })
                
                
             return TerceriasEnLista;
        }
    },
    mounted(){
        this.DocumentoParaLista = this.DocumentoPadre;
        this.Volumenes = this.DocumentoPadre.Volumenes;
        this.Incidentes = this.DocumentoPadre.Incidentes;
        this.Tercerias = this.DocumentoPadre.Tercerias;
        this.Mostrar();
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Movimientos/modalModicacionSalaLectura.vue